var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#0C5DA4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7303 13.5519C27.881 13.0979 27.7303 12.7677 27.0628 12.7677H24.8448C24.285 12.7677 24.0266 13.0566 23.8758 13.3662C23.8758 13.3662 22.7346 16.0076 21.1411 17.7204C20.6243 18.2156 20.3874 18.3807 20.1075 18.3807C19.9568 18.3807 19.763 18.2156 19.763 17.7616V13.5312C19.763 12.9947 19.5907 12.7471 19.117 12.7471H15.6286C15.284 12.7471 15.0687 12.9947 15.0687 13.2423C15.0687 13.7582 15.8654 13.8821 15.9516 15.3266V18.4633C15.9516 19.1443 15.8224 19.2681 15.5424 19.2681C14.7888 19.2681 12.9584 16.606 11.8603 13.5725C11.6449 12.9741 11.4296 12.7471 10.8697 12.7471H8.63025C7.98425 12.7471 7.87659 13.036 7.87659 13.3455C7.87659 13.9027 8.63025 16.7092 11.3865 20.4237C13.2169 22.9619 15.8224 24.3239 18.1695 24.3239C19.5907 24.3239 19.763 24.0144 19.763 23.4985V21.5793C19.763 20.9602 19.8922 20.8571 20.3444 20.8571C20.6674 20.8571 21.2488 21.0221 22.5623 22.2397C24.0696 23.6842 24.328 24.3446 25.1678 24.3446H27.3858C28.0318 24.3446 28.3332 24.035 28.161 23.4366C27.9672 22.8381 27.235 21.9714 26.2876 20.9396C25.7708 20.3618 24.9956 19.7221 24.7587 19.4125C24.4357 18.9998 24.5218 18.8347 24.7587 18.4633C24.7372 18.4633 27.4504 14.79 27.7303 13.5519Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterVk);
export default __webpack_public_path__ + "static/media/footer-vk.9d3129ffb81691dc9f0ac65c2c5f5b50.svg";
export { ForwardRef as ReactComponent };